import { render } from "./snackbar-container.vue?vue&type=template&id=401b7e7d&scoped=true&ts=true&lang=pug"
import script from "./snackbar-container.vue?vue&type=script&lang=ts"
export * from "./snackbar-container.vue?vue&type=script&lang=ts"

import "./snackbar-container.vue?vue&type=style&index=0&id=401b7e7d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401b7e7d"]])

export default __exports__